import FormJaivana from 'dashboard_jaivana_v1';
/**
 * @description: CustomImpuestosImpuestosClientesTarifas
 * @author: Anderson Acevedo
 * @version: jdesk_1.01.0009.1
 **/
class CustomImpuestosImpuestosClientesTarifas extends FormJaivana.form {

    constructor(props) {
        super(props);
        this.initForm = this.initForm.bind(this);
        this.arrayObjetos = new Map();
        this.arrayCampos = new Map();
        this.crearRegistro = this.crearRegistro.bind(this);
        this.successCrear = this.successCrear.bind(this);
        this.actualiarRegistro = this.actualiarRegistro.bind(this);
        this.successActualizar = this.successActualizar.bind(this);

        this.traerPrimero = this.traerPrimero.bind(this);
        this.successtraerPrimero = this.successtraerPrimero.bind(this);
        this.traerUltimo = this.traerUltimo.bind(this);
        this.successtraerUltimo = this.successtraerUltimo.bind(this);
        this.traerPorId = this.traerPorId.bind(this);
        this.successtraerPorId = this.successtraerPorId.bind(this);
        /*this.validarRegistroEliminar = this.validarRegistroEliminar.bind(this);
        this.succesvalidarRegistroEliminar = this.succesvalidarRegistroEliminar.bind(this);*/
        this.eliminarPorId = this.eliminarPorId.bind(this);
        this.successeliminarPorId = this.successeliminarPorId.bind(this);
        this.btnModificar = false;
        this.onClickChange = this.handlerClickChange.bind(this);
        this.onClickShowTable = this.handerClickShowTable.bind(this);
        this.onClickNew = this.handlerClickNew.bind(this);
        this.onClickDelete = this.handlerClickDelete.bind(this);
        this.onSelectionChanged = this.onSelectionChanged.bind(this);
        this.registro_seleccionado = false;
        this.mostrarMensajeSeleccionModificar = this.mostrarMensajeSeleccionModificar.bind(this);
        this.mostrarMensajeSeleccionEliminar = this.mostrarMensajeSeleccionEliminar.bind(this);
        this.successValidarUniqueRegistro = this.successValidarUniqueRegistro.bind(this);
        this.traerTodos = this.traerTodos.bind(this);
        this.successtraerTodos = this.successtraerTodos.bind(this);
        this.confirmarEliminacionRegistro = this.confirmarEliminacionRegistro.bind(this);
        this.validarDescripcionUpdate = this.validarDescripcionUpdate.bind(this);
        this.successvalidarDescripcionUpdate = this.successvalidarDescripcionUpdate.bind(this);
        this.validacionUnique = this.validacionUnique.bind(this);
        this.successValidarUniqueRegistro = this.successValidarUniqueRegistro.bind(this);

        this.traerEstados = this.traerEstados.bind(this);
        this.sucesstraeEstados = this.sucesstraeEstados.bind(this);
        //imprimir

            this.mostrarMensajeNoHayDatos                         =this.mostrarMensajeNoHayDatos.bind(this);
            this.mostrarMensajeAdicional                         =this.mostrarMensajeAdicional.bind(this);
            this.mostrarMensajeGenerando                         =this.mostrarMensajeGenerando.bind(this);

        this.currencyFormatterGeneral = this.currencyFormatterGeneral.bind(this);
        this.formatNumberSaldo = this.formatNumberSaldo.bind(this);
        this.llenar = this.llenar.bind(this);
        this.traer_por_id = false;
        this.sucursal_ingreso ='';

    }
    


    initForm() {
        console.log('Formulario CustomImpuestosImpuestosClientesTarifas,  @version: jdesk_1.01.0009.3, @author:Anderson Acevedo, Fecha Modificación: 26/05/2025')
        this.sucursal_ingreso = JSON.parse(localStorage.getItem('sucursal_ingreso')).codigo_sucursal;
        this.getField('impuestos_clientes_tarifas_id').setVisible(false);
        this.arrayCampos.set(1, 'impuestos_tarifas_id');
        this.arrayCampos.set(2, 'codigo_impuesto');
        this.arrayCampos.set(3, 'nombre_impuesto');
        this.arrayCampos.set(4, 'valor_base');
        this.arrayCampos.set(5, 'base_formula');
        this.arrayCampos.set(6, 'tarifa');
        this.arrayCampos.set(7, 'nit');
        this.arrayCampos.set(8, 'sede');
        this.arrayCampos.set(9, 'nombre');
        this.arrayCampos.set(10, 'estado_activo_id');
        this.arrayCampos.set(11, 'acumular_por_dia');
        this.arrayCampos.set(12, 'usado_en');
 


        this.arrayCampos.set(30, 'btn_agregar');
        this.arrayCampos.set(31, 'btn_cancelar');
        this.arrayCampos.set(32, 'btn_modificar');
        this.arrayCampos.set(33, 'btn_cancelar_modificar');
        //this.arrayCampos.set(34,'operacion');

        this.arrayObjetos.set(1, 'impuestos_tarifas_id');
        this.arrayObjetos.set(2, 'codigo_impuesto');
        this.arrayObjetos.set(3, 'nombre_impuesto');
        this.arrayObjetos.set(4, 'valor_base');
        this.arrayObjetos.set(5, 'base_formula');
        this.arrayObjetos.set(6, 'tarifa');
        this.arrayObjetos.set(7, 'nit');
        this.arrayObjetos.set(8, 'sede');
        this.arrayObjetos.set(9, 'nombre');
        this.arrayObjetos.set(10, 'estado_activo_id');
        this.arrayObjetos.set(11, 'acumular_por_dia');
        this.arrayObjetos.set(12, 'usado_en');

        this.arrayObjetos.set(30, 'btn_agregar');
        this.arrayObjetos.set(31, 'btn_cancelar');
        this.arrayObjetos.set(32, 'btn_modificar');
        this.arrayObjetos.set(33, 'btn_cancelar_modificar');
        //this.arrayObjetos.set(34,'operacion');
        this.establecerPropiedades('1,2,3,4,5,7,8,9,10,11,12', 'visible', 'false')
        this.establecerPropiedades('1,2,3,4,5,7,8,9,10,11,12', 'disable', 'true')

        //inicio form
        this.establecerPropiedades('2,3,4,5,7,8,9,10,11,12', 'visible', 'true');

        let opciones = [
            { 'text': 'Ninguno', 'value': '', 'campos_cambian': {}},
            { 'text': 'Ninguno', 'value': '.', 'campos_cambian': {}},
            { 'text': 'Base exenta', 'value': 'Base exenta', 'campos_cambian': {}},
            { 'text': 'Base gravada', 'value': 'Base gravada', 'campos_cambian': {}},
            { 'text': 'Base exenta+Base gravada', 'value': 'Base exenta+Base gravada', 'campos_cambian': {}},
            { 'text': 'Valor iva', 'value': 'Valor iva', 'campos_cambian': {}},
        ];
        this.getField('formula_base1').setOptions(opciones);



        this.getField('btn_cancelar').setClick(() => {
            this.traer_por_id = false;
            this.btnCancelarRegistro();
        });
        this.getField('btn_agregar').setClick(() => {
            if (this.getField("codigo_impuesto").valid() &&
            this.getField("nombre_impuesto").valid() && this.getField('nombre_impuesto').valid() &&
            this.getField("nit").valid() &&
            this.getField("sede").valid()  && 
            this.getField('valor_base').valid() &&  this.getField('base_formula').valid() &&  this.getField('tarifa').valid() && 
            this.getField('acumular_por_dia').valid()  &&  this.getField('usado_en').valid()
            && this.getField("estado_activo_id").valid()){
                this.validacionUnique();
            }
        });

        this.getField('btn_modificar').setClick(() => {
            if (this.getField("codigo_impuesto").valid() &&
            this.getField("nombre_impuesto").valid() && this.getField('nombre_impuesto').valid() &&
            this.getField("nit").valid() &&
            this.getField("sede").valid()  && 
            this.getField('valor_base').valid() &&  this.getField('base_formula').valid() &&  this.getField('tarifa').valid() && 
            this.getField('acumular_por_dia').valid()  &&  this.getField('usado_en').valid()
            && this.getField("estado_activo_id").valid()){
                this.validarDescripcionUpdate();
            }
        });

        this.getField('btn_cancelar_modificar').setClick(() => {
            this.traer_por_id = false;
            this.btnModificar = false;
            this.btnCancelarRegistro();
        });

        this.traerEstados();


        this.getField('nit').setOnChange(() => {
            this.getField('sede').setError(false,'');
            this.getField('nombre').setError(false,'');
        });

        this.getField('codigo_impuesto').setOnChange(() => {
            this.getField('nombre_impuesto').setError(false,'');
        });

        

        
    }

    traerEstados() {
        let datos = { datos: {
        } };
        this.generalFormatPmv = { tipo_servicio: '2', operacion: '1', operacion_tipo: 'consulta' };
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'GET',
                body: datos,
                success: this.sucesstraeEstados,
                error: this.error_,
                general: this.generalFormatPmv,
                showMessage: false
            });

    }

    sucesstraeEstados(data) {
        this.getField('confirmModalCustom').toggle(false);
        let opciones = [{ 'text': 'Ninguno', 'value': '', 'campos_cambian': {} }];
        if (data.estado_p === 200) {
            data.data.forEach(item => {
                let dataOp = {}
                dataOp['value'] = item.estadosactivos_id;
                dataOp['text'] = item.estadosactivos_descripcion;
                /* dataOp['campos_cambian'] = { rack: item.id }; */
                opciones.push(dataOp);
            });
        } else if (data.estado_p === 404) {
            //this.alertGeneral.toggle(true, 'La consulta no arrojo datos.', 'error');
        }
        else {
            let respuesta = Object.values(data.data.errores);
            this.alertGeneral.toggle(true, 'Error ' + respuesta, 'error');
        }
        this.getField('estado_activo_id').setOptions(opciones);
        this.getField('estado_activo_impuesto_tarifa').setOptions(opciones);
        this.traerUltimo();
    }



    onSelectionChanged() {
        let filaSeleccionada = this.gridOptionsTableDefault.api.getSelectedRows();
        if (filaSeleccionada.length > 0) {
            this.llenar(filaSeleccionada);
            this.registro_seleccionado = true;
        } else {
            this.registro_seleccionado = false;
        }

    }

    handerClickShowTable() {
        this.registro_seleccionado = false;
        this.traer_por_id = false;
        /* this.traerPrimero(); */
        this.traerTodos();

    }

    handlerClickChange() {
        this.btnModificar = true;
        if (this.registro_seleccionado) {
            this.registro_seleccionado = false;
            
            this.establecerPropiedades('4,5,6,7,10,11,12,32,33', 'disable', 'false');
            this.establecerPropiedades('32,33', 'visible', 'true');
            this.getField('btn_new').setVisible(false);
            this.getField('btn_show').setVisible(false);
            this.getField('btn_change').setVisible(false);
            this.getField('btn_delete').setVisible(false);
            this.getField('rejilla').toggle(false);

        } else {
            this.mostrarMensajeSeleccionModificar();
        }
    }

    handlerClickNew() {
        this.btnModificar = false;
        this.registro_seleccionado = false;
        this.traer_por_id = false;
        this.establecerPropiedades('2,3,4,5,6,7,8,10,11,12,30,31', 'disable', 'false');
        this.establecerPropiedades('30,31', 'visible', 'true');
        this.establecerPropiedades('1,2,3,4,5,6,7,8,9,10,11,12', 'value', '');


        this.getField('btn_new').setVisible(false);
        this.getField('btn_show').setVisible(false);
        this.getField('btn_change').setVisible(false);
        this.getField('btn_delete').setVisible(false);
        this.getField('rejilla').toggle(false);

        this.getField('valor').setValue('');
        this.getField('base').setValue('');

        this.getField('formula_base1').setValue('.');
        this.getField('estado_activo_impuesto_tarifa').setValue(' ');

    }

    handlerClickDelete() {
        this.traer_por_id = false;
        if (this.registro_seleccionado) {
            this.confirmarEliminacionRegistro();
        } else {
            this.mostrarMensajeSeleccionEliminar();
        }
    }

    mostrarMensajeSeleccionModificar() {
        this.getField('confirmModalCustom').setTitleAndContent('Mensaje', 'No se ha seleccionado ningún registro para modificar');
        this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
    }

    mostrarMensajeSeleccionEliminar() {
        this.getField('confirmModalCustom').setTitleAndContent('Mensaje', 'No se ha seleccionado ningún registro para eliminar');
        this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
    }

    btnCancelarRegistro() {
        this.getField('confirmModalCustom').toggle(false);
        this.registro_seleccionado = false;
        this.getField('btn_agregar').setVisible(false);
        this.getField('btn_cancelar').setVisible(false);
        this.getField('btn_modificar').setVisible(false);
        this.getField('btn_cancelar_modificar').setVisible(false);
        this.getField('btn_new').setDisabled(false);
        this.getField('btn_show').setDisabled(false);
        this.getField('btn_delete').setDisabled(false);

        this.establecerPropiedades('1,2,3,4,5,6,7,8,9,10,11,12', 'disable', 'true');
        this.establecerPropiedades('1,2,3,4,5,6,7,8,9,10,11,12', 'value', '');
        this.establecerPropiedades('1,2,3,4,5,6,7,8,9,10,11,12', 'error', 'false');
        if (this.traer_por_id)
            this.traerPorId();
        else
            this.traerUltimo();
        this.traerTodos();


        this.getField('btn_new').setVisible(true);
        this.getField('btn_show').setVisible(true);
        this.getField('btn_change').setVisible(true);
        this.getField('btn_delete').setVisible(true);

/*         this.gridOptionsTableDefault["rowData"] = [];
        this.getField('rejilla').initData(this.gridOptionsTableDefault);
        this.getField('rejilla').toggle(false); */
        this.btnModificar = false;
    }

    validacionUnique() {
      
            let datos = {
                datos: {
                    clientes_id: this.getField('clientes_id').getValue(),
                    impuestos_tarifas_id: this.getField('impuestos_tarifas_id').getValue(),
                }
            };

            this.generalFormatPmv = { tipo_servicio: 'maes-impuestosclientestarifas', operacion: '20', operacion_tipo: 'consulta' };
            this.service.send(
                {
                    endpoint: this.constant.formConfiguration(),
                    method: 'GET',
                    body: datos,
                    success: this.successValidarUniqueRegistro,
                    error: this.error_,
                    general: this.generalFormatPmv,
                    showMessage: false
                });
    }

    successValidarUniqueRegistro(data) {
        if (data.estado_p === 200) {
            this.alertGeneral.toggle(true, 'Esta combinación  impuestos tarifas,cliente ya se encuentra asignado a un registro', 'error');
        } else if(data.estado_p === 404){
            if (data.estado_p === 404) {
                this.crearRegistro();
            }
            else {
                let respuesta=Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error ' + respuesta, 'error');
            }
        }
    }

    validarDescripcionUpdate(){
        let datos = {
            datos: {
                clientes_id: this.getField('clientes_id').getValue(),
                impuestos_tarifas_id: this.getField('impuestos_tarifas_id').getValue(),
                impuestos_clientes_tarifas_id: this.getField('impuestos_clientes_tarifas_id').getValue(),
            }
        };
    
        this.generalFormatPmv = { tipo_servicio: 'maes-impuestosclientestarifas', operacion: '21_mod', operacion_tipo: 'consulta' };
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'GET',
                body: datos,
                success: this.successvalidarDescripcionUpdate,
                error: this.error_,
                general: this.generalFormatPmv,
                showMessage: false
            });
    }

    successvalidarDescripcionUpdate(data) {
        if (data.estado_p === 200) {
            this.alertGeneral.toggle(true, 'Esta combinación  impuestos tarifas,cliente ya se encuentra asignado a un registro', 'error');
        } else {
            if (data.estado_p === 404) {
                this.actualiarRegistro();
            }
            else {
                let respuesta=Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error ' + respuesta, 'error');
            }

        }
    }

    traerPorId() {
        let id_bodega = (this.getField('impuestos_clientes_tarifas_id').getValue() === null ||
        this.getField('impuestos_clientes_tarifas_id').getValue() !== '' || 
        this.getField('impuestos_clientes_tarifas_id').getValue() !== ' ' || 
        !isNaN(this.getField('impuestos_clientes_tarifas_id').getValue()) )
        ?  parseInt(localStorage.getItem('impuestos_clientes_tarifas_id')):
        this.getField('impuestos_clientes_tarifas_id').getValue();


        if (id_bodega !== '' && id_bodega !== ' ' && id_bodega !== null && !isNaN(id_bodega) ) {
            let datos = {
                datos: {
                    impuestos_clientes_tarifas_id: id_bodega
                }
            };
            this.generalFormatPmv = { tipo_servicio: 'maes-impuestosclientestarifas', operacion: '2', operacion_tipo: 'consulta' };
            this.service.send(
                {
                    endpoint: this.constant.formConfiguration(),
                    method: 'GET',
                    body: datos,
                    success: this.successtraerPorId,
                    error: this.error_,
                    general: this.generalFormatPmv
                });
            }
    }

    successtraerPorId(data) {
        if (data.estado_p === 200) {
            this.llenar(data.data)
        } /* else {
            if (data.estado_p === 404) {
                this.alertGeneral.toggle(true, 'No se encontro.', 'error');
            }
            else {
                this.alertGeneral.toggle(true, 'Error obteniendo el registro', 'error');
            }
        } */
    }

    confirmarEliminacionRegistro() {
        this.getField('confirmModalCustom').setTitleAndContent('Eliminar', 'Está seguro de realizar esta acción?');
        this.getField('confirmModalCustom').setClickDialog(
            this.eliminarPorId);
        this.getField("confirmModalCustom").setClickCancelDialog (()=>{ 
            this.getField('confirmModalCustom').toggle(false);
            this.registro_seleccionado = true;
             });
        this.getField("confirmModalCustom").setVisibleCancel(false);
        this.getField("confirmModalCustom").setButtonConfirm('Confirmar');
        this.getField('confirmModalCustom').toggle(true);
    }

    /*validarRegistroEliminar() {
        this.getField('confirmModalCustom').toggle(false);
        let datos = { datos: {
            impuestos_tarifas_id :this.getField('impuestos_tarifas_id').getValue(),
        } };
        this.generalFormatPmv = { tipo_servicio: 'maes-impuestosclientestarifas', operacion: '7_validar', operacion_tipo: 'consulta' };
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'GET',
                body: datos,
                success: this.succesvalidarRegistroEliminar,
                error: this.error_,
                general: this.generalFormatPmv
            });  
    }

    succesvalidarRegistroEliminar(data) {
        if (data.estado_p === 200) {
            this.eliminarPorId();
        } else {
            let respuesta=Object.values(data.data.errores);
            this.alertGeneral.toggle(true, 'Error ' + respuesta, 'error');

        }
    }*/


    eliminarPorId() {
        this.getField('confirmModalCustom').toggle(false);
        let datos = {
            datos: {
                impuestos_clientes_tarifas_id: this.getField('impuestos_clientes_tarifas_id').getValue()
            }
        };
        this.generalFormatPmv = { tipo_servicio: 'maes-impuestosclientestarifas', operacion: '7', operacion_tipo: 'eliminar' };
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'DELETE',
                body: datos,
                success: this.successeliminarPorId,
                error: this.error_,
                general: this.generalFormatPmv,
                showMessage : false
            });
    }

    successeliminarPorId(data) {
        if (data.estado_p === 200) {
            this.registro_seleccionado = false;
            this.getField('confirmModalCustom').toggle(false);
            this.traerPrimero();
            this.traerTodos();
        }
        else {
            let respuesta=Object.values(data.data.errores);
            this.alertGeneral.toggle(true, 'Error ' + respuesta, 'error');
        }
    }

    crearRegistro() {
        this.getField('btn_agregar').setDisabled(true);
            let datos = {
                datos: {
                    
                    impuestos_tarifas_id:this.getField("impuestos_tarifas_id").getValue(),
                    clientes_id:this.getField("clientes_id").getValue(),
                    valor_base: this.getField("valor_base").getValue(),
                    base_formula: this.getField("base_formula").getValue(),
                    tarifa: this.getField("tarifa").getValue(),
                    acumular_por_dia : this.getField('acumular_por_dia').getValue(),
                    usado_en : this.getField('usado_en').getValue(),
                    estado_activo_id:this.getField("estado_activo_id").getValue(),
                }
            }

            this.generalFormatPmv = { tipo_servicio: 'maes-impuestosclientestarifas', operacion: '5', operacion_tipo: 'crear' };
            this.service.send(
                {
                    endpoint: this.constant.formConfiguration(),
                    method: 'POST',
                    body: datos,
                    success: this.successCrear,
                    error: this.error_,
                    general: this.generalFormatPmv,
                    showMessage: false
                });
    }

    successCrear(data) {
        this.getField('btn_agregar').setDisabled(false);
        if (data.estado_p === 200) {
            this.getField('impuestos_tarifas_id').setValue(data.data[0].impuestos_tarifas_id);
            
            //this.traer_por_id = true;
            this.btnCancelarRegistro();
            //this.traerUltimo()
        } else {
            if (data.estado_p === 404) {
                this.alertGeneral.toggle(true, 'La consulta no arrojo datos.', 'error');
            }
            else {
                let respuesta = Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }

    actualiarRegistro() {
        this.getField('btn_modificar').setDisabled(true);
            let datos = {
                datos: {
                    impuestos_clientes_tarifas_id:this.getField("impuestos_clientes_tarifas_id").getValue(),
                    impuestos_tarifas_id:this.getField("impuestos_tarifas_id").getValue(),
                    clientes_id:this.getField("clientes_id").getValue(),
                    valor_base: this.getField("valor_base").getValue(),
                    base_formula: this.getField("base_formula").getValue(),
                    tarifa: this.getField("tarifa").getValue(),
                    acumular_por_dia : this.getField('acumular_por_dia').getValue(),
                    usado_en : this.getField('usado_en').getValue(),
                    estado_activo_id:this.getField("estado_activo_id").getValue(),
                }
            }
        

            
            this.generalFormatPmv = { tipo_servicio: 'maes-impuestosclientestarifas', operacion: '6', operacion_tipo: 'modificar' };
            this.service.send(
                {
                    endpoint: this.constant.formConfiguration(),
                    method: 'PUT',
                    body: datos,
                    success: this.successActualizar,
                    error: this.error_,
                    general: this.generalFormatPmv,
                    showMessage: false,
                });
        
    }

    successActualizar(data) {
        this.getField('btn_modificar').setDisabled(false);
        if (data.estado_p === 200) {
            this.getField('impuestos_clientes_tarifas_id').setValue(data.data[0].impuestos_clientes_tarifas_id);
            localStorage.setItem('impuestos_clientes_tarifas_id', this.getField('impuestos_clientes_tarifas_id').getValue().toString())
            this.traer_por_id = true;
            this.btnCancelarRegistro();
        }
        else {
            if (data.estado_p === 404) {
                this.alertGeneral.toggle(true, 'No se pudo actualizar el registro', 'error');
            }
            else {
                this.alertGeneral.toggle(true, 'Error actualizando el registro', 'error');
            }
        }
    }


    traerTodos() {
        let datos = { datos: {} };
        this.generalFormatPmv = { tipo_servicio: 'maes-impuestosclientestarifas', operacion: '1', operacion_tipo: 'consulta' };
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'GET',
                body: datos,
                success: this.successtraerTodos,
                error: this.error_,
                general: this.generalFormatPmv,
                showMessage: false,
            });
    }

    successtraerTodos(data) {
        if (data.estado_p === 200) {
            //armar tabla
            let configCell = new Map();
            configCell.set('base_valor', { cellRenderer: (props) => { return "" + this.currencyFormatterGeneral(props.data.base_valor) }, cellStyle: { textAlign: "right" }, width: 110 });
            configCell.set('tarifa', { cellRenderer: (props) => { return "" + this.currencyFormatterGeneral(props.data.tarifa) }, cellStyle: { textAlign: "right" }, width: 110 });
            configCell.set('sede', { cellRenderer: (props) => { return "" + this.currencyFormatterGeneral(props.data.sede) }, cellStyle: { textAlign: "right" }, width: 110 });
            configCell.set('valor_impuesto_tarifa', { cellRenderer: (props) => { return "" + this.currencyFormatterGeneral(props.data.valor_impuesto_tarifa) }, cellStyle: { textAlign: "right" }, width: 110 });
            configCell.set('base_impuesto_tarifa', { cellRenderer: (props) => { return "" + this.currencyFormatterGeneral(props.data.base_impuesto_tarifa) }, cellStyle: { textAlign: "right" }, width: 110 });


            this.gridOptionsTableDefault['rowData'] = data.model;//los datos del servicio se cargan en la tabla por defecto del crud
            this.gridOptionsTableDefault['onSelectionChanged'] = this.onSelectionChanged;
            this.getField('rejilla').initData(this.gridOptionsTableDefault, configCell);
            this.registro_seleccionado = false;
        }
        else {
            if (data.estado_p === 404) {
                this.alertGeneral.toggle(true, 'No se encontro.', 'error');
            }
            else {

                this.alertGeneral.toggle(true, 'Error al traer todos los registros', 'error');
            }
        }
    }

    traerPrimero() {
        let datos = { datos: {} };
        this.generalFormatPmv = { tipo_servicio: 'maes-impuestosclientestarifas', operacion: '3', operacion_tipo: 'consulta' };
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'GET',
                body: datos,
                success: this.successtraerPrimero,
                error: this.error_,
                general: this.generalFormatPmv,
                showMessage: false,
            });
    }

    successtraerPrimero(data) {
        if (data.estado_p === 200) {
            this.llenar(data.data);
        } else {
            if (data.estado_p === 404) {
                this.alertGeneral.toggle(true, 'No se encontro el registro.', 'error');
            }
            else {
                this.alertGeneral.toggle(true, 'Error Obteniendo el registro', 'error');
            }
        }
    }

    traerUltimo() {
        let datos = { datos: {} };
        this.generalFormatPmv = { tipo_servicio: 'maes-impuestosclientestarifas', operacion: '4', operacion_tipo: 'consulta' };
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'GET',
                body: datos,
                success: this.successtraerUltimo,
                error: this.error_,
                general: this.generalFormatPmv,
                showMessage: false,
            });
    }

    successtraerUltimo(data) {
        if (data.estado_p === 200) {
            this.llenar(data.data);
        }
        else {
            if (data.estado_p === 404) {
                this.alertGeneral.toggle(true, 'No se encontro.', 'error');
            } else {
                let respuesta = Object.values(data.data.errores);
                let keys = Object.keys(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + keys + ' - ' + respuesta, 'error');
            }
        }
    }

    llenar(data) {
       
        this.getField('codigo_impuesto').setValue(data[0].codigo);
        this.getField('nombre_impuesto').setValue(data[0].nombre);
  
        this.getField('base_formula').setValue(data[0].base_formula);
        this.getField('tarifa').setValue(data[0].tarifa);

        this.getField('nit').setValue(data[0].nit);
        this.getField('sede').setValue(data[0].sede);
        this.getField('nombre').setValue(data[0].nombre_cliente);
        this.getField('valor_base').setValue(data[0].base_valor);
        this.getField('acumular_por_dia').setValue(data[0].acumular_por_dia);
        this.getField('usado_en').setValue(data[0].usado_en);
        this.getField('estado_activo_id').setValue(data[0].estado_activo_id);

        this.getField('impuestos_clientes_tarifas_id').setValue(data[0].impuestos_clientes_tarifas_id);
        this.getField('clientes_id').setValue(data[0].clientes_id);
        this.getField('impuestos_tarifas_id').setValue(data[0].impuestos_tarifas_id);


        this.getField('valor').setValue(data[0].valor_impuesto_tarifa);
        this.getField('base').setValue(data[0].base_impuesto_tarifa);
        this.getField('formula_base1').setValue(data[0].formula_base_impuesto_tarifa);
        this.getField('estado_activo_impuesto_tarifa').setValue(data[0].estado_activo_impuesto_tarifa);
    
    }




    establecerPropiedades(sObjetos, sPropiedad, sValor) {
        const array = sObjetos.split(',');
        array.forEach((element) => {
            if (sPropiedad === 'disable') {
                if (sValor === 'true') {
                    this.getField(this.arrayObjetos.get(parseInt(element))).setDisabled(true);
                }
                else {
                    this.getField(this.arrayObjetos.get(parseInt(element))).setDisabled(false);
                }
            }
            else if (sPropiedad === 'visible') {
                if (sValor === 'true') {
                    this.getField(this.arrayObjetos.get(parseInt(element))).setVisible(true);
                }
                else {
                    this.getField(this.arrayObjetos.get(parseInt(element))).setVisible(false);
                }
            }
            else if (sPropiedad === 'value') {
                this.getField(this.arrayObjetos.get(parseInt(element))).setValue(sValor);
            }
            else if (sPropiedad === 'valid') {
                if (this.getField(this.arrayObjetos.get(parseInt(element))).isValid()) {
                    //ok
                }
                else {
                    this.bHayErrores = true;
                }
            }
            else if (sPropiedad === 'foco') {
                if (sValor === 'rejilla') { }
                else {
                    this.getField(this.arrayObjetos.get(parseInt(element))).input.focus();
                }
            }
            else if (sPropiedad === 'error') {
                if (sValor === 'false') {
                    this.getField(this.arrayObjetos.get(parseInt(element))).setError(false, '');
                }
            }
        });
    }

    currencyFormatterGeneral(number) {
        let decimal = (number + "").split(".")[1];//para manejar los decimales
        if ((decimal !== 0) && (decimal !== undefined)) {
            if (decimal.length > 2) {
                decimal = (Number(number).toFixed(2) + "").split(".")[1];
            }
            return (this.formatNumberSaldo(number) + "," + decimal);
        } else {
            return this.formatNumberSaldo(number);
        }
    }

    formatNumberSaldo(number) {
        return Number(number).toString().split('.')[0]
            .toString()
            .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
    }



  mostrarMensajeNoHayDatos(){
    this.getField('confirmModalCustom').setTitleAndContent('Mensaje', 'La consulta no arrojo datos.');
    this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); });
    this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
    this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
    this.getField('confirmModalCustom').toggle(true);
}

    mostrarMensajeAdicional(mensaje){
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Compras', mensaje);
        this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
    }

    mostrarMensajeGenerando(){
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Advertencia', `No recargue la página, por favor espere, se está generando la información... `);
        this.getField('confirmModalCustom').setClickDialog(()=>{});  
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("."); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
    }


}
FormJaivana.addController("maes-impuestosclientestarifas", CustomImpuestosImpuestosClientesTarifas);
export default CustomImpuestosImpuestosClientesTarifas